import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { emptyArr, emptyObj } from '@beef/utils';
import { createCurrentHOC } from '@beef/redux';
import { createMergedBlockSelector, getInfoCardsModuleData } from "../../selectors";
import { getInfoCardsBlock } from "../selectors";
import { POPUP_TYPES } from "./constants";
var getInfoCardsData = createMergedBlockSelector(getInfoCardsBlock);
export var getInfoCardsList = function getInfoCardsList(state) {
  return getInfoCardsData(state).list || emptyArr;
};
export var getInfoCardFootnote = function getInfoCardFootnote(state) {
  return getInfoCardsData(state).footnote;
};
export var getInfoCardIconSize = function getInfoCardIconSize(state) {
  return getInfoCardsData(state).iconSize;
};

// @ts-expect-error fix later
var _createCurrentHOC = createCurrentHOC(getInfoCardsList, function (item) {
    return item.text;
  }),
  _createCurrentHOC2 = _slicedToArray(_createCurrentHOC, 2),
  getCurrentInfoCard = _createCurrentHOC2[0],
  withInfoCardMapper = _createCurrentHOC2[1];
export { getCurrentInfoCard, withInfoCardMapper };
export var getInfoCardsPopupTexts = function getInfoCardsPopupTexts(state) {
  return getInfoCardsData(state).popupTexts || emptyObj;
};
export var getCurrentPopupStep = function getCurrentPopupStep(state) {
  return getInfoCardsModuleData(state).popupStep;
};
export var getInfoCardsSupportPopupData = function getInfoCardsSupportPopupData(state) {
  return getInfoCardsPopupTexts(state).supportInfoList || emptyObj;
};
export var isRenderSupportInfoListPopup = function isRenderSupportInfoListPopup(state) {
  return getCurrentPopupStep(state) === POPUP_TYPES.supportInfoList;
};
export var getSupportInfoListItems = function getSupportInfoListItems(state) {
  return getInfoCardsSupportPopupData(state).list || emptyArr;
};
export var getInfoCardsAppDownloadPopupData = function getInfoCardsAppDownloadPopupData(state) {
  return getInfoCardsPopupTexts(state).appDownload || emptyObj;
};
export var isRenderAppDownloadPopup = function isRenderAppDownloadPopup(state) {
  return getCurrentPopupStep(state) === POPUP_TYPES.appDownload;
};
export var getAppDownloadLink = function getAppDownloadLink(state) {
  return getInfoCardsAppDownloadPopupData(state).link;
};
export var getAppDownloadText = function getAppDownloadText(state) {
  return getInfoCardsAppDownloadPopupData(state).text || '';
};
export var getAppDownloadList = function getAppDownloadList(state) {
  return getInfoCardsAppDownloadPopupData(state).appList || emptyArr;
};